import { func, number } from "prop-types";
import Modal from "@shared/v2/Modal";
import Button from "@shared/v2/Button/Button";

const UpdateOrCreateConfirmModal = ({ isCreate, closeOptionsModal, saveDialog, count }) => (
  <Modal
    className="tw-flex tw-justify-center tw-items-center"
    dialogClassName="!tw-w-[480px] tw-h-auto"
    contentClassName="tw-w-full tw-h-full"
    backdrop="static"
    show
    onHide={closeOptionsModal}
  >
    <Modal.Header
      titleClassName="tw-mb-32px tw-text-gray-75"
      title={isCreate ? "Creating Market Reports" : "Updated Market Reports"}
      closeButton
    />

    <Modal.Body>
      {isCreate ? (
        <p className="tw-pb-[32px]">
          Market reports are being created and sent to {count} recipient(s). Check back in a few minutes or
          refresh the page until you see the updates applied.
        </p>
      ) : (
        <>
          <p>
            Market Report drip frequency is being updated. This can take anywhere from 0-5 minutes. Check back
            in a few minutes, or refresh the page until you see the updates applied.{" "}
            <span className="tw-font-bold">Do not attempt to apply it again. </span>
          </p>
          <p className="tw-pb-[32px]">
            If the frequency hasn't updated after 10 minutes, please contact by calling Support at
            855-427-4848.
          </p>
        </>
      )}
    </Modal.Body>
    <Modal.Footer className="tw-flex tw-flex-row tw-justify-between ">
      <Button size="medium" schema="tertiary" onClick={closeOptionsModal}>
        Close
      </Button>

      <Button size="medium" schema="primary" onClick={saveDialog}>
        got it
      </Button>
    </Modal.Footer>
  </Modal>
);
UpdateOrCreateConfirmModal.propTypes = {
  closeOptionsModal: func,
  saveDialog: func,
  count: number,
};

UpdateOrCreateConfirmModal.defaultProps = {
  closeOptionsModal: null,
  saveDialog: null,
  count: 0,
};
export default UpdateOrCreateConfirmModal;
